import { render, staticRenderFns } from "./FieldDate.vue?vue&type=template&id=2fa3c60e"
import script from "./FieldDate.vue?vue&type=script&lang=js"
export * from "./FieldDate.vue?vue&type=script&lang=js"
import style0 from "./FieldDate.vue?vue&type=style&index=0&id=2fa3c60e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports